import { render, staticRenderFns } from "./LoadAdd.vue?vue&type=template&id=049501be&scoped=true"
import script from "./LoadAdd.vue?vue&type=script&lang=js"
export * from "./LoadAdd.vue?vue&type=script&lang=js"
import style0 from "./LoadAdd.vue?vue&type=style&index=0&id=049501be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049501be",
  null
  
)

export default component.exports